import { Card } from 'react-bootstrap';

import { TotalUnbilledTrafficTable } from '@components/Dashboard/TotalUnbilledTraffic/TotalUnbilledTrafficTable';
import { DefaultSpinnerCenter } from '@components/Loader/Loader';
import { dashboardApi } from '@reducers/dashboard/dashboard';

export const TotalUnbilledTraffic = () => {
  const { data, isLoading } = dashboardApi.useTotalUnbilledTrafficQuery();
  return (
    <Card>
      <Card.Header className="text-center bg-didxl text-white">
        Total Unbilled Traffic
      </Card.Header>
      <Card.Body className="normalFontSize">
        {isLoading && <DefaultSpinnerCenter />}
        {!isLoading && <TotalUnbilledTrafficTable data={[data]} />}
      </Card.Body>
    </Card>
  );
};
